module.exports = __webpack_public_path__ + "static/img/02.480bca0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/companies/immark/02.jpg
// module id = 393
// module chunks = 1